import React from "react";
import styled from "styled-components";

// @ts-ignore - JSX コンポーネント（型定義なし）
import ListBlock from "../../../components/block/ListBlock";

/**
 * 「〇〇を追加」用の `ListBlock type="add"` を親要素いっぱいに広げて表示するラッパー。
 *
 * Roles 系画面の追加ボタン（「ロールを追加」「行を追加」「タグを追加」など）で
 * 共通のレイアウト規約（全幅表示）を共有するために用意した薄いコンポーネント。
 *
 * 親が `.u-col`（`align-items: flex-start`）配下でも、`width: 100%` を明示
 * することで親いっぱいに広がる。
 */
const Wrapper = styled.div`
  width: 100%;
`;

interface FullWidthAddBlockProps {
  label: string;
  onClick: () => void;
}

const FullWidthAddBlock: React.FC<FullWidthAddBlockProps> = ({
  label,
  onClick,
}) => (
  <Wrapper>
    <ListBlock type="add" label={label} onClick={onClick} />
  </Wrapper>
);

export default FullWidthAddBlock;
